/**
 * Application Deadline Section Component
 * Displays application deadline or estimated expiry date
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

export interface ApplicationDeadlineSectionProps {
  formattedApplicationDate: string | null;
  formattedEstimatedExpiryDate: string | null;
  formattedPostedDate: string | null;
}

export const ApplicationDeadlineSection: React.FC<ApplicationDeadlineSectionProps> = ({
  formattedApplicationDate,
  formattedEstimatedExpiryDate,
  formattedPostedDate,
}) => {
  if (!formattedApplicationDate && !formattedEstimatedExpiryDate) {
    return null;
  }

  return (
    <div className="mb-6 p-4 rounded-2xl bg-orange-50 dark:bg-orange-900/20 border-2 border-orange-200 dark:border-orange-800 shadow-md">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/40 flex items-center justify-center">
          <svg className="h-6 w-6 text-orange-600 dark:text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <div className="flex-1">
          <div className="text-xs font-semibold text-orange-700 dark:text-orange-300 mb-1 uppercase tracking-wide">
            {formattedEstimatedExpiryDate ? (
              <FormattedMessage id="jobDetailPage.estimatedExpiry" defaultMessage="Estimated Expiry" description="Section label for estimated job posting expiry date" />
            ) : (
              <FormattedMessage id="jobDetailPage.applicationDeadline" defaultMessage="Application Deadline" description="Section label for job application deadline date" />
            )}
          </div>
          <div className="text-lg font-bold text-orange-900 dark:text-orange-100">
            {formattedEstimatedExpiryDate || formattedApplicationDate}
          </div>
          {formattedPostedDate && (
            <div className="text-xs text-orange-600 dark:text-orange-400 mt-1">
              <FormattedMessage id="hit.postedDate.detail" defaultMessage="Posted: {date}" values={{ date: formattedPostedDate }} description="Job posting date shown on job detail page" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
